import React from 'react';
import OriginalIntlTelInput, {
  CountryData,
  IntlTelInputProps as OriginalIntlTelInputProps,
} from 'react-intl-tel-input';
import styled from 'styled-components';
import classNames from 'classnames';
import { isPossiblePhoneNumber, CountryCode } from 'libphonenumber-js';

interface IntlTelInputProps extends OriginalIntlTelInputProps {
  className?: string;
  containerClassName?: string;
  inputClassName?: string;
  onPhoneNumberChange?: (isValid: boolean, value: string, countryData: CountryData, fullNumber: string) => void;
  onPhoneNumberBlur?: (isValid: boolean, value: string, countryData: CountryData, fullNumber: string) => void;
}

function IntlTelInput(props: IntlTelInputProps) {
  const { className, containerClassName, inputClassName, onPhoneNumberChange, onPhoneNumberBlur, ...otherProps } =
    props;

  function phoneNumberChangeHandler(_isValid: boolean, value: string, countryData: CountryData, fullNumber: string) {
    const overriddenValidateStatus = isPossiblePhoneNumber(value, countryData.iso2?.toUpperCase() as CountryCode);
    return onPhoneNumberChange?.(overriddenValidateStatus, value, countryData, fullNumber);
  }

  function phoneNumberBlurHandler(_isValid: boolean, value: string, countryData: CountryData, fullNumber: string) {
    const overriddenValidateStatus = isPossiblePhoneNumber(value, countryData.iso2?.toUpperCase() as CountryCode);
    return onPhoneNumberBlur?.(overriddenValidateStatus, value, countryData, fullNumber);
  }

  return (
    <OriginalIntlTelInput
      {...otherProps}
      containerClassName={classNames(['intl-tel-input', className, containerClassName])}
      inputClassName={classNames(['ant-input', 'ant-input-lg', inputClassName])}
      {...(onPhoneNumberChange && { onPhoneNumberChange: phoneNumberChangeHandler })}
      {...(onPhoneNumberBlur && { onPhoneNumberBlur: phoneNumberBlurHandler })}
    />
  );
}

// Deal with css pollution by global styles for `div.arrow` in `src/index.css`.
const StyledIntlTelInput = styled(IntlTelInput)`
  & div.arrow {
    width: unset;
    height: unset;
    background: unset;
    position: unset;
    margin-top: unset;

    &:before {
      content: none;
    }

    &:after {
      position: unset;
      border-style: unset;
      border-width: unset;
      border-color: unset;
      display: unset;
      width: unset;
      z-index: unset;
      top: unset;
      left: unset;
    }
  }
`;

export default StyledIntlTelInput;
